import { render, staticRenderFns } from "./MargemContribuicao.vue?vue&type=template&id=309eb006&"
import script from "./MargemContribuicao.vue?vue&type=script&lang=js&"
export * from "./MargemContribuicao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/margem-roi/MargemContribuicao.vue
// module id = 1435
// module chunks = 28